/**
 * Step Indicator
 * ** Receives Params:
 * ** ** stepUrls: Array of routes (strings) -JE
 * ** ** steps: Array of Page names (strings - and not sure why method chosen) -JE
 * ** ** ** chosen to create labels on progress bar -JE
 * ** ** Vanilla react can't track router data this way -JE
 * ** ** ** Used `window.location.pathname` instead -JE
 * ** ** currentStep: Number - index of route in array -JE
 * ** ** ** changed to route passed from `window.location.pathname` -JE
 */

import React from 'react';
import PropTypes from 'prop-types';
import './StepIndicator.scss';
import checkmark from '../../assets/checkmark.svg';

const StepIndicator = ({ steps, currentStep, stepUrls }) => {
  const progressStyle = () => {
    const percent = (stepUrls.indexOf(currentStep) / (steps.length - 1)) * 99;
    return { width: `${percent}%` };
  };

  const stepIndicatorStyle = (idx) => {
    const last = currentStep === stepUrls.at(-1) ? 'last ' : '';
    const current = stepUrls.indexOf(currentStep) === idx ? 'current ' : '';
    const complete = idx < stepUrls.indexOf(currentStep) ? 'complete ' : '';
    return `${last}${current}${complete} step-indicator`;
  };

  const setTestId = (step, idx) => {
    const last = currentStep === stepUrls.at(-1) ? 'last-' : '';
    const current = stepUrls.indexOf(currentStep) === idx ? 'current-' : '';
    const complete = idx < stepUrls.indexOf(currentStep) ? 'complete-' : '';
    return `${last}${current}${complete}${step.toLowerCase()}`;
  };

  const ProgressBar = () =>
    steps.map((step, idx) => (
      <div
        className={stepIndicatorStyle(idx)}
        key={step}
        data-testid={setTestId(step, idx)}
      >
        <span className="step-name">{step}</span>
        <img alt="checkmark" src={checkmark} />
      </div>
    ));

  return (
    <div className="steps-container" aria-hidden>
      <div className="steps-outer-wrapper">
        <div className="steps-bar" />
        <div className="steps-bar progress" style={progressStyle()} />

        <div className="steps-wrapper">{ProgressBar()}</div>
      </div>
    </div>
  );
};

StepIndicator.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentStep: PropTypes.string.isRequired,
  stepUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default StepIndicator;
